const { connect } = require('react-redux');
const BrokerCustomWalletPortfolioItem = require ('./brokerCustomWalletPortfolioItem');
// @ actions
const brokerCustomWalletIntervenersActions = require('../../actions/brokerCustomWalletInterveners');

module.exports.BrokerCustomWalletPortfolioItem = connect(
    state => ({
        immBrokerCustomWalletInterveners: state.brokerCustomWalletInterveners
    }),{
        getInterveners: brokerCustomWalletIntervenersActions.getInterveners,
    }
)(BrokerCustomWalletPortfolioItem);
